import { initFeedback } from "./feedback/index.js";
function initQa() {
    initFeedback();
}

window.onload = () => {
    initQa();
}